export const videoBaseUrl = import.meta.env.VITE_VIDEO_BASE_URL || window.VITE_VIDEO_BASE_URL || "https://vod.api.video";
export const apiBaseUrl = import.meta.env.VITE_BASE_URL || window.VITE_BASE_URL || "https://api.dev.tahseen.cloud/";
